import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../api/fetcher";
import { queryKeys } from "../../api/keys";
import { Button } from "../../components/control/Button";
import { ErrorBanner } from "../../components/feedback/ErrorBanner";
import { Dialog } from "../../components/overlay/Dialog";
import { useBookDetail } from "./bookContext";
import { BookMetadataForm } from "./overview/BookMetadataForm";
export function MetadataConfirmation() {
  const book = useBookDetail();
  const { t } = useTranslation("nav");
  const client = useQueryClient();
  const [dismissed, setDismissed] = useState(false);
  const extraction = useMutation({
    mutationFn: () => api(`/books/${book.id}/metadata/extract`, { method: "POST" }),
    onSuccess: () => client.invalidateQueries({ queryKey: queryKeys.book(book.id) }),
  });
  const shouldExtract =
    !book.metadataConfirmedAt &&
    !book.confirmedAt &&
    book.state === "parsed" &&
    !book.metadataExtraction &&
    !book.activeJobs.some((j) => j.kind === "metadata" || j.kind === "parse");
  useEffect(() => {
    if (shouldExtract && !extraction.isPending && !extraction.isError) extraction.mutate();
  }, [shouldExtract, extraction.isPending, extraction.isError, extraction.mutate]);
  const ready =
    book.metadataExtraction?.status === "ready" || book.metadataExtraction?.status === "failed";
  return (
    <Dialog
      open={
        !book.metadataConfirmedAt &&
        !book.confirmedAt &&
        (ready || extraction.isError) &&
        !dismissed
      }
      title={t("workspace.confirmMetadata")}
      onClose={() => setDismissed(true)}
      footer={
        <Button variant="secondary" onClick={() => setDismissed(true)}>
          {t("workspace.later")}
        </Button>
      }
    >
      {book.metadataExtraction?.status === "failed" || extraction.isError ? (
        <div className="mb-4 space-y-2">
          <p>{t("workspace.metadataFailure")}</p>
          <Button
            variant="secondary"
            busy={extraction.isPending}
            onClick={() => extraction.mutate()}
          >
            {t("workspace.extractRetry")}
          </Button>
        </div>
      ) : null}
      <ErrorBanner error={extraction.error} />
      <BookMetadataForm inline onClose={() => setDismissed(true)} />
    </Dialog>
  );
}
